import * as React from "react"
import { Container } from '../components';
import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function Services({ category }) {

    const data = useStaticQuery(graphql`
    query {
      retirementPlanningImage: file(relativePath: { eq: "retirement-planning-header.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      investmentsImage: file(relativePath: { eq: "investments-feature.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      mortgagePropertyImage: file(relativePath: { eq: "property-investments.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      financialPlanningImage: file(relativePath: { eq: "financial-advice.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      currencyTransfersImage: file(relativePath: { eq: "currency-transfers.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      } 
      residencyImage: file(relativePath: { eq: "residency-image.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      insuranceImage: file(relativePath: { eq: "insurance-image.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      estatePlanningImage: file(relativePath: { eq: "estate-planning.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      taxPlanningImage: file(relativePath: { eq: "taxPlanning.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      financialTools: file(relativePath: { eq: "financial-tools.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      ukStatePension: file(relativePath: { eq: "uk-state-pension-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      pensionTransfer: file(relativePath: { eq: "pension-transfers-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      sipps: file(relativePath: { eq: "sipps-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      qrops: file(relativePath: { eq: "qrops-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      
      

      employeeBenefitsImage: file(relativePath: { eq: "employee-benefits.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      investmentOption: file(relativePath: { eq: "investment-options-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      PortfolioAssetManagement: file(relativePath: { eq: "portfolio-and-management-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      wealthManagement: file(relativePath: { eq: "wealth-management-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      educationPlanning: file(relativePath: { eq: "education-planning-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      investmentOptions: file(relativePath: { eq: "investment-options-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      internationalProperty: file(relativePath: { eq: "international-property-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      ukMortgages: file(relativePath: { eq: "uk-mortgages-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      propertyInvestment: file(relativePath: { eq: "property-investment-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      criticalIllness: file(relativePath: { eq: "critical-illness-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      incomeProtection: file(relativePath: { eq: "income-protection-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      lifeInsurance: file(relativePath: { eq: "live-insurance-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      medicalInsurance: file(relativePath: { eq: "medical-insurance-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      wills: file(relativePath: { eq: "wills-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      trustAndGifting: file(relativePath: { eq: "trust-and-gifting-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
     
    

      wealthTaxPlanning: file(relativePath: { eq: "wealth-tax-planning-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      spanishTaxPlanning: file(relativePath: { eq: "spanish-tax-planning-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }



      mortgageCalculator: file(relativePath: { eq: "mortgage-calculator-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }

      savingsCalculator: file(relativePath: { eq: "savings-calculator-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      retirementCalculator: file(relativePath: { eq: "retirement-calculator-thumb.webp" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
 
    }
  `);


    const services = [
        {
          title: "Retirement Planning",
          image: getImage(data.retirementPlanningImage),
          link: "/our-services/retirement-planning/",
          description: "Don't let your retirement be an afterthought. The sooner you start your retirement planning, the better",
        },
        {
          title: "Investments",
          image: getImage(data.investmentsImage),
          link: "/our-services/investments/",
          description: "You have the vision; we have the investment options",
        },
        {
          title: "Mortgage & Property",
          image: getImage(data.mortgagePropertyImage),
          link: "/our-services/mortgage-property/",
          description: "Our end-to-end service makes securing an international mortgage or investing in property straightforward",
        },
        {
          title: "Financial Planning",
          image: getImage(data.financialPlanningImage),
          link: "/our-services/financial-planning/",
          description: "Creating a bespoke and comprehensive plan to suit your financial needs",
        },
        {
          title: "Currency Transfers",
          image: getImage(data.currencyTransfersImage),
          link: "/our-services/currency-transfers/",
          description: "Quick and efficient international currency transfers",
        },
        {
          title: "Residency",
          image: getImage(data.residencyImage),
          link: "/our-services/residency/",
          description: "Open up a world of possibilities through our dedicated programmes",
        },
        {
          title: "Insurance",
          image: getImage(data.insuranceImage),
          link: "/our-services/insurance/",
          description: "Protect yourself and your family from unforeseen life events",
        },
        {
          title: "Estate Planning",
          image: getImage(data.estatePlanningImage),
          link: "/our-services/estate-planning/",
          description: "Estate planning is essential to ensure your loved ones are looked after financially",
        },
       
        {
          title: "Tax Planning",
          image: getImage(data.taxPlanningImage),
          link: "/our-services/tax-planning/",
          description: "Whether you are moving to Spain to work or retire, it is essential that you understand the country’s tax rules and how they could affect you",
        },
        {
          title: "Financial Tools",
          image: getImage(data.financialTools),
          link: "/our-services/financial-tools/",
          description: "A selection of tools to get started on your journey to financial freedom.",
      },
    ]

    const retirement = [
      {
          title: "UK State Pension",
          image: getImage(data.ukStatePension),
          link: "/our-services/retirement-planning/uk-state-pension/",
          description: "The UK State Pension is a regular payment from the Government to support you in later life.",
      },
      {
          title: "Pension Transfers",
          image: getImage(data.pensionTransfer),
          link: "/our-services/retirement-planning/pension-transfers/",
          description: "If you decide to retire abroad, transferring your UK pension could open up a world of possibilities.",
      },
      {
          title: "SIPPs",
          image: getImage(data.sipps),
          link: "/our-services/retirement-planning/sipp/",
          description: "A Self-Invested Personal Pension (SIPP) is a type of pension that allows you to choose and manage your own investments.",
      },   
      {
        title: "QROPS",
        image: getImage(data.qrops),
        link: "/our-services/retirement-planning/qrop/",
        description: "A Qualifying Recognised Overseas Pension Scheme (QROPS) is an overseas pension scheme that meets certain requirements set by HM Revenue and Customs (HMRC).",
      }
    ]

    const investments = [
        {
            title: "Education Planning",
            image: getImage(data.educationPlanning),
            link: "/our-services/investments/education-planning/",
            description: "",
        },
        {
            title: "Investments Options",
            image: getImage(data.investmentOptions),
            link: "/our-services/investments/investment-options/",
            description: "",
        },
        {
            title: "Portfolio & Asset Management",
            image: getImage(data.PortfolioAssetManagement),
            link: "/our-services/investments/portfolio-asset-management/",
            description: "",
        },
        {
            title: "Wealth Management",
            image: getImage(data.wealthManagement),
            link: "/our-services/investments/wealth-management/",
            description: "",
        },
    ]

    const mortgageProperty = [
      {
        title: "International Property",
        image: getImage(data.internationalProperty),
        link: "/our-services/mortgage-property/international-property/",
      },
      {
        title: "UK Mortgages",
        image: getImage(data.ukMortgages),
        link: "/our-services/mortgage-property/uk-mortgages/",
      },
      {
        title: "Property Investment",
        image: getImage(data.propertyInvestment),
        link: "/our-services/mortgage-property/property-investment/",
      }
    ]


    const insurance = [
      {
          title: "Critical Illness",
          image: getImage(data.criticalIllness),
          link: "/our-services/insurance/critical-illness/",
      },
      {
          title: "Income Protection",
          image: getImage(data.incomeProtection),
          link: "/our-services/insurance/income-protection/",
      },
      {
          title: "Life Insurance",
          image: getImage(data.lifeInsurance),
          link: "/our-services/insurance/life-insurance/",
      },
      {
          title: "Medical Insurance",
          image: getImage(data.medicalInsurance),
          link: "/our-services/insurance/medical-insurance/",
      },
  ]

    const estate = [
      {
        title: "Wills",
        image: getImage(data.wills),
        link: "/our-services/estate-planning/wills/",
    },
      {
          title: "Trusts & Gifting",
          image: getImage(data.trustAndGifting),
          link: "/our-services/estate-planning/trusts-and-gifting/",
      },
    ]

      const taxPlanning = [
        {
          title: "Wealth Tax Planning",
          image: getImage(data.wealthTaxPlanning),
          link: "/our-services/tax-planning/wealth-tax-planning/",
      },
        {
            title: "Spanish Tax Planning",
            image: getImage(data.spanishTaxPlanning),
            link: "/our-services/tax-planning/spanish-tax-planning/",
        },
    ]

    const financialTools = [
      {
        title: "Mortgage Calculator",
        image: getImage(data.mortgageCalculator),
        link: "/our-services/financial-tools/mortgage-calculator/",
    },
      {
          title: "Savings Calculator",
          image: getImage(data.savingsCalculator),
          link: "/our-services/financial-tools/savings-calculator/",
      },
      {
        title: "Retirement Calculator",
        image: getImage(data.retirementCalculator),
        link: "/our-services/financial-tools/retirement-calculator/",
    },
  ]




    let sectionTitle;
    let selectedServices;
    let gridClasses;

    switch (category) {
        case 'investments':
            selectedServices = investments;
            sectionTitle = "Our Investment Services";
            gridClasses = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10";
            break;
        case 'insurance':
            selectedServices = insurance;
            sectionTitle = "Our Insurance Services";
            gridClasses = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10";
            break;
        case 'retirement':
            selectedServices = retirement;
            sectionTitle = "Our Retirement Planning Services";
            gridClasses = "grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-10";
            break;
        case 'estate':
            selectedServices = estate;
            sectionTitle = "Our Estate Planning Services";
            gridClasses = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10";
            break;
        case 'mortgageProperty':
              selectedServices = mortgageProperty;
              sectionTitle = "Our Estate Planning Services";
              gridClasses = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10";
              break;
        case 'taxPlanning':
              selectedServices = taxPlanning;
              sectionTitle = "Our Tax Planning Services";
              gridClasses = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10";
              break;
        case 'financialTools':
              selectedServices = financialTools;
              sectionTitle = "Our Financial Tools Services";
              gridClasses = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10";
              break;
        default:
            selectedServices = services;
            sectionTitle = "Our Areas of Expertise";
            gridClasses = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10";
    }

    return (
        <Container className="services bg-white">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-14 mx-auto text-center">
                <div className="col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12">
                    <h2 className="text-3xl mb-6 pb-10 font-semibold">{sectionTitle}</h2>
                    <div className={gridClasses}>
                        { (category === 'estate' || category === 'taxPlanning') && <div className="hidden xl:block xl:col-span-1"></div> }
                        {selectedServices.map((service, index) => (
                            <Link key={index} to={service.link}>
                                <div className="services-card bg-light-blue h-full">
                                    <div className="services-card-image">
                                        <GatsbyImage image={service.image} alt={service.title} />
                                    </div>
                                    <div className="services-content-wrapper p-6">
                                      <div className="services-card-title">
                                        <h3 className="pb-0">{service.title}</h3>
                                      </div>
                                      {service.description && (
                                        <div className="services-card-text flex-grow pt-4">
                                          <p>{service.description}</p>
                                        </div>
                                      )}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default Services;

